module.exports = __webpack_public_path__ + "img/图1-35角度线的运笔方向及徒手画法.6b54d634.jpg";